export const getLoginName = () => {
    let loginName = "";
    if (localStorage.getItem("loginUserInfo")) {
      const info = JSON.parse(localStorage.getItem("loginUserInfo"));
      loginName = info?.employee_name || info?.user_name || "";
    }
    return loginName;
}

export const getLoginUuid = () => {
    let loginUserUuid = "";
    if (localStorage.getItem("loginUserInfo")) {
      loginUserUuid = JSON.parse(localStorage.getItem("loginUserInfo")).user_uuid;
    }
    return loginUserUuid;
}

export const getLoginEmployeeUuid = () => {
  let loginEmployeeUuid = "";
  if (localStorage.getItem("loginUserInfo")) {
    loginEmployeeUuid = JSON.parse(localStorage.getItem("loginUserInfo")).employee_uuid;
  }
  return loginEmployeeUuid;
}
